import { MoneyText, type MoneyTextProps } from '@paguz/ui';
import { useSyncExternalStore } from 'react';

/** Preferencia "ocultar montos" (por dispositivo). */
const KEY = 'paguz.web.hide-amounts';
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return globalThis.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setAmountsHidden(hidden: boolean): void {
  try {
    globalThis.localStorage.setItem(KEY, hidden ? '1' : '0');
  } catch {
    // sin almacenamiento: no persiste
  }
  for (const listener of listeners) listener();
}

export function useAmountsHidden(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    read,
    () => false,
  );
}

/** `MoneyText` que respeta "ocultar montos". */
export function PrivateMoney(props: MoneyTextProps) {
  const hidden = useAmountsHidden();
  if (!hidden) return <MoneyText {...props} />;
  return (
    <span className={props.className} aria-label="Monto oculto">
      $ ••••••
    </span>
  );
}

/** Signo de presentación de un movimiento (las cifras vienen positivas de la API). */
export function signedAmount(amount: string, isCredit: boolean): string {
  return isCredit ? amount : `-${amount}`;
}
